import React, { Component } from 'react';
import {  Link } from "react-router-dom";
import './index.scss';



export default  class RouterMovingContainer extends Component {
  constructor(props) {
    super(props)
    this.currentIndex = 0;
    this.pastIndex = -1;
  
    this.data = [];
  }
  setIndex = (e) => {
    this.currentIndex = e;
  }
  execute = (i, current) => {
    setTimeout(() => {
      if (i === current) {
        if (this.data[current] && this.data[current].wrappedInstance && this.data[current].wrappedInstance.onEnterScreen) {
          this.data[current].wrappedInstance.onEnterScreen()
        }
      }
      if (this.currentIndex === i) {
     
      }

    }, this.props.options && this.props.options.animation && this.props.options.animation.duration ? this.props.options.animation.duration : 250)
  }
  render() {
    let routing = this.props.availableRoutes;

    let path = this.props.history.location.pathname;
    var i;
    // arr.splice(0, 0, "Lene");


    
    for (i = 0; i < routing.length; i++) {
        if (routing[i].route === path) {
          this.pastIndex = this.currentIndex;
          // this.pastIndex = i;
          this.currentIndex = i;
  
          routing[i].loaded = true;
        }
    }

    // let diff = Math.abs(this.pastIndex - this.currentIndex)
    // if (diff > 1) {
    //   alert ('asd')
    //   let cache_route = routing[this.currentIndex];
    //   routing.splice(this.currentIndex, 1);
    //   // this.pastIndex = this.currentIndex;
    //   this.currentIndex  = this.pastIndex + 1;
    //   routing.splice(this.currentIndex, 0, cache_route);
    
    // for (i = 0; i < routing.length; i++) {
    //   if (routing[i].route === path) {
    //     routing[i].loaded = true;
    //   }
    // }
    // this.props.setRoutes(routing)
    // }


    let length  = routing.length
    let transform = `translate3d(-${((this.currentIndex / length) * 100)}%,0,0)`;
    
    let width = `${length*100}%`;
    let height = '100%';
    if (this.props.options && this.props.options.animation && this.props.options.animation.type) {
    
      switch(this.props.options.animation.type) {
        case 'scale':
            transform = `translate3d(0,0,0)`;
            width = '100%';

            break;
        case 'rotate':
          transform = `translate3d(0,0,0)`;
          width = '100%';

        break;
        case 'fade':
          transform = `translate3d(0,0,0)`;
          width = '100%';

         break;
        default:
          transform = `translate3d(0,0,0)`;
          width = '100%';
          break;
    }
    }
    if (this.props.options && this.props.options.animation && this.props.options.animation.move) {
      switch(this.props.options.animation.move) {
        case 'left':
            transform = `translate3d(-${((this.currentIndex / length) *100)}%,0,0)`;
            width = `${length*100}%`;
            break;
        case 'top':
            transform = `translate3d(0,-${((this.currentIndex / length) *100)}%,0)`;
            width = `100%`;
            height = `${length*100}%`;
            break;
        default:
            //same as top
            transform = `translate3d(0,-${((this.currentIndex / length) *100)}%,0)`;
            width = `100%`;
            height = `${length*100}%`;
            break;
      }
 
    }
    
    return (
      <div className={`authContainer ${this.props.parentClassName}`}>
            <div  className={`authContainer-child ${this.props.className ? this.props.className : ''}`}>
              <div style={{
                transition:this.props.options && this.props.options.animation && this.props.options.animation.duration ? `all ${this.props.options.animation.duration} cubic-bezier(0.4, 0, 0.2, 1)` : `all 0.25s cubic-bezier(0.4, 0, 0.2, 1)`,
                width:width,
                transform:transform,
                height:height,
                
                }} className={`authContainer-child-in`}>
                      {
                        routing.map((item, i) =>{
                            
                            let style = {
                              transform:`translate3d(0,0,0)`,
                              position:'relative',
                              transition:this.props.options && this.props.options.animation && this.props.options.animation.duration ? `all ${this.props.options.animation.duration} cubic-bezier(0.4, 0, 0.2, 1)` : `all 0.25s cubic-bezier(0.4, 0, 0.2, 1)`,
                            };
                            if (this.props.options && this.props.options.animation && this.props.options.animation.type) {
                              switch(this.props.options.animation.type) {
                                case 'scale':
                                    style.transform = `translate3d(0, 0, ${(this.currentIndex - i) * 1000}px)`;
                                    style.position = 'absolute';
                                    style.opacity = i === this.currentIndex ? 1 : 0;
                                    style.pointerEvents = i === this.currentIndex ? 'auto' : 'none';
                                    break;
                                case 'rotate':
                                    style.transform = `rotate${this.props.options && this.props.options.animation && this.props.options.animation.rorateAxis ? this.props.options.animation.rorateAxis : 'X'}(${(this.currentIndex - i) * 90}deg)`;
                                    style.position = 'absolute';
                                    style.opacity = i === this.currentIndex ? 1 : 0;
                                    style.pointerEvents = i === this.currentIndex ? 'auto' : 'none';
                                break;
                                case 'fade':
                                  style.position = 'absolute';
                                  style.opacity = i === this.currentIndex ? 1 : 0;
                                  style.pointerEvents = i === this.currentIndex ? 'auto' : 'none';
                                break;
                                default:
                                  //same as fade
                                  style.position = 'absolute';
                                  style.opacity = i === this.currentIndex ? 1 : 0;
                                  style.pointerEvents = i === this.currentIndex ? 'auto' : 'none';
                                  break
                              }
                            }
                            if (this.props.options && this.props.options.animation && this.props.options.animation.move) {
                              switch(this.props.options.animation.move) {
                                case 'top':
                                    style.position = 'absolute';
                                    // style.opacity = i === this.currentIndex ? 1 : 0;
                                    // style.pointerEvents = i === this.currentIndex ? 'auto' : 'none';
                                    break;
                                default:
                                    style.position = 'absolute';
                                    // style.opacity = i === this.currentIndex ? 1 : 0;
                                    // style.pointerEvents = i === this.currentIndex ? 'auto' : 'none';
                                    break;
                              }

                            }
                 
                              this.execute(i, this.currentIndex)
                              return <div key={'router'+i} style={style} className={`authContainer-moving ${this.props.className}`}>
                              
                                
                                {/* LAZY LOADING */}
                                {item.component && item.loaded ? <item.component
                                ref ={ (data) => {this.data[i] = data}}
                                {...item.props}
                                {...this.props}

                                /> : null}
                                {/* <item.component
                                ref ={ (data) => {this.data[i] = data}}
                                {...item.props}
                                {...this.props}

                                /> */}
                                {this.props.options && this.props.options.showLinks ?
                                     routing.map((item, i) =>{
                                      return <li key={i+'liii'}><Link to={item.route}>{item.route}</Link></li>;
                                     })
                                : null}
                              </div>
                         })
                    }
               </div>
            </div>
      </div>
    );
  }
}







// WEBPACK FOOTER //
// ./src/components/functional/animated-router/animationContainerRows.js